import { ReactComponent as IconDate } from '@/assets/svgs/icon-date.svg'
import classname from 'classnames'
import PropTypes from "prop-types"
import { forwardRef } from 'react'
import ReactDatePicker from "react-datepicker"

const DatePicker = ({ "data-testid": dataTestId, selectDate, setSelectDate, placeHolderText, dateFormat, showTimeFormat, disable, addClass, ...datePickerProps }) => {
	const dateFormatText = dateFormat ? dateFormat : "dd/MM/yyyy h:mm aa"

	const datePickerClassName = classname(
		addClass,
		{
			date_picker__format: true
		}
	)

	const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
		<div data-testid={dataTestId} className={datePickerClassName} onClick={onClick} ref={ref}>
			{
				!value && (
					<>
						<IconDate />
						<span className="date_picker__selected-empty">
							{placeHolderText ?? "Date"}
						</span>
					</>
				)
			}
			{
				value && (
					<span>
						{value}
					</span>
				)
			}
		</div>
	));


	return (
		<div className="date_picker__container">
			<ReactDatePicker
				selected={selectDate}
				dateFormat={dateFormatText}
				customInput={<CustomDateInput />}
				onChange={(date) => setSelectDate(date)}
				isClearable
				disabled={disable}
				{...datePickerProps}
			/>
		</div>


	)
}

DatePicker.propTypes = {
	"data-testid": PropTypes.string,
	selectDate: PropTypes.instanceOf(Date),
	setSelectDate: PropTypes.func,
	placeHolderText: PropTypes.string,
	dateFormat: PropTypes.string,
	showTimeFormat: PropTypes.bool,
	disable: PropTypes.bool,
	addClass: PropTypes.string,
}

export default DatePicker
